import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { MDBDataTable, MDBBtn } from "mdbreact";
import { adminActions } from "../../../redux/actions";
import Pagination from "../../includes/Pagination";
import PrimaryLoader from "../../includes/Loaders/PrimaryLoader";
import TableLoader from "../../includes/Loaders/TableLoader";
import ReuseableSearchBar from "../../search/search";
import PageNumber from "../../includes/PageNumber";

export default function Tiers() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { page } = useParams();

  const loading = useSelector((state) => state.admin.loading);
  const searching = useSelector((state) => state.admin.searching);
  const allVerificationLevel = useSelector(
    (state) => state.admin.allVerificationLevel
  );

  const [payLoad] = useState({
    end_date: new Date(),
  });
  console.log("allVerificationLevel", allVerificationLevel);

  useEffect(() => {
    dispatch(adminActions.filterHumanVerificationLevel(payLoad, page));
  }, [dispatch, page, payLoad]);

  const goToPage = () => {
    history.push(`/kyc/create-tier`);
  };

  // function goToSinglePage(user_id) {
  //   history.push(`/kyc/single-user/${user_id}`);
  // }

  let kycData = allVerificationLevel?.data;

  function createTableData() {
    let dataToMap = kycData && kycData.data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((tier, index) => {
        let singleRowArray = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          title: tier.title,
          daily: tier.daily_limit,
          monthly: tier.monthly_limit,
          date: moment(tier.created_at).format("MMM DD, YYYY"),
          // action: (
          //   <MDBBtn onClick={() => goToSinglePage(tier.user_id)}>
          //     View Details
          //   </MDBBtn>
          // ),
          tierData: tier,
        };
        outputArray.push(singleRowArray);
        return true;
      });
      return outputArray;
    }
  }
  const dataSet = createTableData();

  const data = {
    columns: [
      {
        label: "S/N",
        field: "num",
        sort: "asc",
        width: 150,
      },
      {
        label: "Title",
        field: "title",
        sort: "asc",
        width: 100,
      },
      {
        label: "Daily Limit",
        field: "daily",
        sort: "asc",
        width: 150,
      },
      {
        label: "Monthly Limit",
        field: "monthly",
        sort: "asc",
        width: 100,
      },
      {
        label: "Created On",
        field: "date",
        sort: "asc",
        width: 150,
      },
      // {
      //   label: "Action",
      //   field: "action",
      //   sort: "asc",
      //   width: 150,
      // },
    ],
    rows: dataSet,
  };

  return (
    <>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className="main-content">
          <div className=" d-flex justify-content-between  align-items-center flex-wrap mb-3">
            <h1 className="mr-2">KYC Tiers</h1>
            <div className="d-flex justify-content-end align-items-center ">
              <MDBBtn color="primary" onClick={() => goToPage()}>
                Create KYC Tier
              </MDBBtn>
            </div>
          </div>
          <div className="separator-breadcrumb border-top" />
          <div className="search-page">
            <PageNumber data={kycData} route="kyc/tiers" />
            <ReuseableSearchBar
              // companyId={company_id}
              page={page}
              searchAction={adminActions.searchHumanVerificationLevel}
              clearSearchResultsAction={adminActions.filterHumanVerificationLevel(
                payLoad,
                1
              )}
            />
          </div>

          <div>
            {loading || searching ? (
              <TableLoader />
            ) : (
              <MDBDataTable
                responsive
                entries={8}
                entriesOptions={[8, 10, 15]}
                bordered
                // maxHeight="400px"
                theadColor="MDBTableHeader"
                hover
                noBottomColumns
                data={data}
                paging={false}
                searching={false}
              />
            )}
          </div>
          <Pagination data={kycData} route="kyc/tiers" />
        </div>
      )}
    </>
  );
}
